import { render } from "./ProductPublicSell.vue?vue&type=template&id=040b57cf"
import script from "./ProductPublicSell.vue?vue&type=script&lang=js"
export * from "./ProductPublicSell.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__